import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__ from "@orbit-ui/core";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE__collapsible_index_js_dd19e588__ from "../collapsible/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__dropdown_menu_index_js_24fce419__ from "../dropdown-menu/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__sidebar_index_js_27c6ba5b__ from "../sidebar/index.js";
function NavigationSection({ title, children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__sidebar_index_js_27c6ba5b__.SidebarGroup, {
            className: "p-0",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__sidebar_index_js_27c6ba5b__.SidebarGroupLabel, {
                    children: title
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__sidebar_index_js_27c6ba5b__.SidebarGroupContent, {
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__sidebar_index_js_27c6ba5b__.SidebarMenu, {
                        children: children
                    })
                })
            ]
        }, title)
    });
}
function NavigationItemButton({ children, asChild }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__sidebar_index_js_27c6ba5b__.SidebarMenuItem, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__sidebar_index_js_27c6ba5b__.SidebarMenuButton, {
            asChild: asChild,
            children: children
        })
    });
}
function NavigationDropdown({ children, isActive = false }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__collapsible_index_js_dd19e588__.Collapsible, {
        asChild: true,
        defaultOpen: isActive,
        className: "group/collapsible",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__sidebar_index_js_27c6ba5b__.SidebarMenuItem, {
            children: children
        })
    });
}
function NavigationDropdownTrigger({ children, tooltip }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__collapsible_index_js_dd19e588__.CollapsibleTrigger, {
        asChild: true,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__sidebar_index_js_27c6ba5b__.SidebarMenuButton, {
            tooltip: tooltip,
            children: [
                children,
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.ChevronRightIcon, {
                    className: "ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90"
                })
            ]
        })
    });
}
function NavigationDropdownContent({ children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__collapsible_index_js_dd19e588__.CollapsibleContent, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__sidebar_index_js_27c6ba5b__.SidebarMenuSub, {
            className: "pr-0",
            children: children
        })
    });
}
function NavigationDropdownItem({ children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__sidebar_index_js_27c6ba5b__.SidebarMenuSubItem, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__sidebar_index_js_27c6ba5b__.SidebarMenuSubButton, {
            asChild: true,
            children: children
        })
    });
}
function NavigationPopOutMenuContent({ children }) {
    const isMobile = (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.useIsMobile)();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dropdown_menu_index_js_24fce419__.DropdownMenu, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dropdown_menu_index_js_24fce419__.DropdownMenuTrigger, {
                asChild: true,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__sidebar_index_js_27c6ba5b__.SidebarMenuAction, {
                    showOnHover: true,
                    className: "right-1.5",
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.MoreHorizontalIcon, {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                            className: "sr-only",
                            children: "More"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dropdown_menu_index_js_24fce419__.DropdownMenuContent, {
                className: "w-48 rounded-lg",
                side: isMobile ? 'bottom' : 'right',
                align: isMobile ? 'end' : 'start',
                children: children
            })
        ]
    });
}
function NavigationPopOutMenuItem({ className, children, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dropdown_menu_index_js_24fce419__.DropdownMenuItem, {
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)('relative flex w-full items-center gap-2 overflow-hidden [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0', className),
        ...props,
        children: children
    });
}
var __webpack_exports__NavigationPopOut = __WEBPACK_EXTERNAL_MODULE__sidebar_index_js_27c6ba5b__.SidebarMenuItem;
var __webpack_exports__NavigationPopOutButton = __WEBPACK_EXTERNAL_MODULE__sidebar_index_js_27c6ba5b__.SidebarMenuButton;
export { NavigationDropdown, NavigationDropdownContent, NavigationDropdownItem, NavigationDropdownTrigger, NavigationItemButton, NavigationPopOutMenuContent, NavigationPopOutMenuItem, NavigationSection, __webpack_exports__NavigationPopOut as NavigationPopOut, __webpack_exports__NavigationPopOutButton as NavigationPopOutButton };

//# sourceMappingURL=index.js.map